module.exports = __webpack_public_path__ + "static/media/my-site.a289388c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/my-site.png
// module id = 40
// module chunks = 0